// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2J6tX","col":"styles_col__Be5WP"};